import { testimonials } from "@/mocks/comics";

export default function About() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-10 items-start">
          {/* about text */}
          <div>
            <span className="inline-flex items-center gap-1.5 text-secondary-700 text-sm font-medium">
              <i className="ri-information-line" />
              ABOUT US
            </span>
            <h2 className="mt-2 font-heading text-2xl md:text-4xl text-foreground-950">关于 51 漫画追更</h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              51漫画追更立志做「更新最快的免费漫画追更站」。我们聚合全网热门连载、国漫新番与海外精品，坚持免费开放、免注册直读，让每一位漫迷都能第一时间看到最新章节，追更不断更。
            </p>
            <div className="mt-6 grid grid-cols-1 sm:grid-cols-3 gap-3">
              <div className="rounded-xl bg-background-50 border border-background-200 p-4">
                <p className="font-heading text-xl text-primary-600">免费</p>
                <p className="mt-1 text-xs text-foreground-600">免注册、免付费直接看</p>
              </div>
              <div className="rounded-xl bg-background-50 border border-background-200 p-4">
                <p className="font-heading text-xl text-primary-600">更新快</p>
                <p className="mt-1 text-xs text-foreground-600">同步全网最新一话</p>
              </div>
              <div className="rounded-xl bg-background-50 border border-background-200 p-4">
                <p className="font-heading text-xl text-primary-600">追更省心</p>
                <p className="mt-1 text-xs text-foreground-600">收藏书架自动记进度</p>
              </div>
            </div>
          </div>

          {/* testimonials */}
          <div>
            <span className="inline-flex items-center gap-1.5 text-accent-700 text-sm font-medium">
              <i className="ri-double-quotes-l" />
              WORD OF MOUTH
            </span>
            <h3 className="mt-2 font-heading text-2xl text-foreground-950">漫迷们的真实口碑</h3>
            <div className="mt-5 space-y-3">
              {testimonials.map((t) => (
                <figure
                  key={t.name}
                  className="rounded-xl bg-background-50 border border-background-200 p-4 md:p-5 transition-colors hover:border-accent-300"
                >
                  <blockquote className="text-sm md:text-base text-foreground-700 leading-relaxed">
                    “{t.quote}”
                  </blockquote>
                  <figcaption className="mt-3 flex items-center gap-3">
                    <span className="flex items-center justify-center w-9 h-9 rounded-full bg-primary-500/15 text-primary-700 font-medium">
                      {t.name.charAt(0)}
                    </span>
                    <span>
                      <span className="block text-sm font-medium text-foreground-950">{t.name}</span>
                      <span className="block text-xs text-foreground-500">{t.role}</span>
                    </span>
                  </figcaption>
                </figure>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}